import { RouteObject } from 'react-router-dom'

import ProgressionQueryPage from '../pages/Query'

const advancedRoutes: RouteObject[] = [
  { path: '/query', element: <ProgressionQueryPage /> },
]

export default advancedRoutes
